import React from 'react';
import s from '../Card.scss';
import { LinkWrapper } from '../../../components/BaseComp';
import { timestampToTime } from '../util';
import { FeedInstance, isFeedInstance } from '../../../models/feed';
// import { PromotionInstance } from '../../../models/apis/promotion';
import { calcCategotyLayout } from '../../../utils/calcCategoryLayout';
import { CategoryLoadingCard } from './Loading';
import { CisItem } from '../../../models/apis/batchCisApi';

export interface CategoryConfig {
    size: number,
    target: string,
    title: string,
    source: CisItem[],
    spmCode: {
        title?: string,
        content: string,
    },
    type: 'video' | 'category' | 'own',
    showLoading?: boolean,
    placeholder?: string,
}

const addition = {
    own: 10,
    category: 10,
    video: -22,
};

export const CategoryCard = (props: CategoryConfig) => {

    const { title, size, target, spmCode, source, type, showLoading = false, placeholder = 'origin' } = props;
    const data: FeedInstance[] = [];
    source.forEach(item => {
        if (isFeedInstance(item) && data.length < size) {
            data.push(item);
        }
    });
    const isVideo = type === 'video';
    const willShowBoolean = showLoading && typeof window !== 'undefined';
    const firstFeedDispatch = (item: FeedInstance) => {

        let imgUrl = item.bigCover || item.cover || (item.images && item.images[0]) || '';
        imgUrl = imgUrl
            .replace(/c_cut/g, 'c_lfill')
            .replace(/w_([\s\S]+?),/g, 'w_260,')
            .replace(/h_([\s\S]+?)(,|\/)/g, 'h_172$2');
        // TODO: Abstruct these comps
        if (type === 'video') {
            return (
                <div key={item.id} className={s.first} data-spm-type="resource">

                    <LinkWrapper href={item.url} className={s.coverBox}>
                        {
                            (s.cover && isVideo)
                                ? <div className={[s.icon, 'bicon-play'].join(' ')} />
                                : <></>
                        }
                        <img src={imgUrl} className={s.cover} />
                    </LinkWrapper>
                    <div className={s.titleBox}>
                        <li className={s.feedTitle}><LinkWrapper href={item.url} data-spm-type="content"> {item.title} </LinkWrapper></li>
                        <b>
                            <LinkWrapper href={item.personalPage || item.url}>{isVideo ? '搜狐视频' : item.authorName}</LinkWrapper>
                            {
                                item.cmt
                                    ? [' · ', item.cmt, '评论'].join(' ')
                                    : timestampToTime(item.publicTime)
                            }
                        </b>
                    </div>
                </div>
            );
        }
        if (type === 'own') {
            return (
                <div key={item.id} className={s.specialBox} data-spm-type="resource" >
                    <LinkWrapper href={item.url}>
                        <p className={s.title}>{item.title}</p>
                    </LinkWrapper>
                    <LinkWrapper href={item.url} className={s.content}>
                        <img src={imgUrl} className={s.cover} />
                        <p className={s.brief}>{item!.brief}</p>
                    </LinkWrapper>
                </div >
            );
        }
        return (
            <div key={item.id} className={[s.specialBox, s.category].join(' ')} data-spm-type="resource" >
                <LinkWrapper href={item.url}>
                    <p className={s.title}>{item.title}</p>
                </LinkWrapper>
                <LinkWrapper href={item.url} className={s.content}>
                    <img src={imgUrl} className={s.cover} alt=''/>
                    <img src={`//statics.itc.cn/asm/static/images/placeholders/${placeholder}.png`} className={s.placeholder}/>
                    <p className={s.brief}>{item!.brief}</p>
                </LinkWrapper>
            </div >
        );
    };

    return (
        <div className={s.cardContainer} style={{ height: calcCategotyLayout(size) + addition[type] }}>
            <div data-spm={spmCode.title}>
                <h3 className={s.title}><span>{title}</span></h3>
                {
                    target
                        ? <LinkWrapper className={s.more} href={target}>更多<i className={'bicon-right'} /></LinkWrapper>
                        : null
                }
            </div>
            {
                data.length
                    ? <div data-spm={spmCode.content}>
                        {data && data.map((item, index) => {
                            let imgUrl = item.bigCover || item.cover || (item.images && item.images[0]) || '';
                            imgUrl = imgUrl
                                .replace(/c_cut/g, 'c_lfill')
                                .replace(/w_([\s\S]+?),/g, 'w_260,')
                                .replace(/h_([\s\S]+?)(,|\/)/g, 'h_172$2');
                            return index === 0 ? (
                                firstFeedDispatch(item)
                            ) : (
                                    <li key={`${index}${item.id}`} className={s.feedTitle}>
                                        <LinkWrapper href={item.url}>
                                            {
                                                isVideo
                                                    ? <span className={s.videoIcon}><i className={[s.icon, 'bicon-play'].join(' ')} />{item.duration}</span>
                                                    : <></>
                                            }
                                            {item.title}
                                        </LinkWrapper>
                                    </li>
                                );
                        })}
                    </div>
                    : (willShowBoolean ? <CategoryLoadingCard /> : null)
            }
        </div >
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/CategoryCard/index.tsx